// extracted by mini-css-extract-plugin
module.exports = {"switch__wrapper":"switch__wrapper-2gcM7","switch__active":"switch__active-1Uxjh"};